// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchTutorial__container___2g4xB","content":"SearchTutorial__content___2Vt9O"};